export const API_Type = {
	Chats: 'Chats',
	Conversations: 'Conversations',
} as const;

export type API_Types = (typeof API_Type)[keyof typeof API_Type];

export const Chat_Type = {
	Message: 'Message',
} as const;

export type Chat_Types = (typeof Chat_Type)[keyof typeof Chat_Type];

export const Conversation_Type = {
	GetConversation: 'GetConversation',
} as const;

export type Conversation_Types =
	(typeof Conversation_Type)[keyof typeof Conversation_Type];
